import actionCreatorFactory from 'typescript-fsa';
const actionCreator = actionCreatorFactory('[app]');

export const queueApiRequest = actionCreator<string>('Queue api request');
export const dequeueApiRequest = actionCreator<string>('Dequeue api request');
